import React from 'react'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import PublicPageSF from '../../templates/PublicPageSF'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import PricingUI from '../../components/public/PricingUI'

const PricingPageUI = ({context, pricingList, messageList,
  countryList, countryCode, onCountryCodeChange}) =>
  <PublicPageSF context={context} className='pg_pricing' backLink='/'
    messageList={messageList} headerMessageKey='c_pricing' centered={!messageList || !pricingList}
  >
    {
      (!messageList || !pricingList) &&
      <SpinnerComponentUI />
    }
    {
      messageList && pricingList &&
      <React.Fragment>
        <PageTitleUI context={context} goBack={true} backLink='/' messageList={messageList} titleMessageKey='c_pricing' />
        <PricingUI context={context} messageList={messageList} pricingList={pricingList}
          countryList={countryList} countryCode={countryCode} onCountryCodeChange={onCountryCodeChange}
        />
      </React.Fragment>
    }
  </PublicPageSF>

export default PricingPageUI
